import { LegendItem } from 'components/Legend/Legend';
import { PitchType, PitchTypeGroup, PlayResult, UmpireCall, UmpireCallCorrectness } from 'types/CodegenReportTypes';
import { pitchTypeGroupToColor, pitchTypeToColor, playResultToColor } from './colorHelpers';

export const configurablePitchTypes: PitchType[] = [
  'All',
  'Changeup',
  'Curveball',
  'Cutter',
  'Fastball',
  'FourSeam',
  'Knuckleball',
  'Sinker',
  'Slider',
  'Splitter',
  'Undefined',
] as const;

export const pitchTypes: PitchType[] = [
  'Changeup',
  'Curveball',
  'Cutter',
  'Fastball',
  'FourSeam',
  'Knuckleball',
  'Sinker',
  'Slider',
  'Splitter',
  'Undefined',
] as const;

export const configurablePitchTypeGroups: PitchTypeGroup[] = ['All', 'Breaking', 'Fastballs', 'Offspeed', 'Undefined'] as const;

export const pitchTypeGroups: PitchTypeGroup[] = ['Breaking', 'Fastballs', 'Offspeed', 'Undefined'] as const;

export const playResults: PlayResult[] = ['Out', 'Single', 'Double', 'Triple', 'HomeRun'] as const;

export const umpireCallOptions: UmpireCall[] = ['BallCalled', 'StrikeCalled'] as const;

export const umpireCallCorrectnessOptions: UmpireCallCorrectness[] = ['BufferZone', 'Correct', 'Incorrect'] as const;

export const pitchCalls: string[] = [
  'BallCalled',
  'FoulBall',
  'FoulBallFieldable',
  'FoulBallNotFieldable',
  'HitByPitch',
  'InPlay',
  'StrikeCalled',
  'StrikeSwinging',
] as const;

const foulBallVariants: string[] = ['FoulBallFieldable', 'FoulBallNotFieldable'] as const;

export const mergeFoulBallVariants = (pitchCall: string): string => (foulBallVariants.includes(pitchCall) ? 'FoulBall' : pitchCall);

export const pitchTypeLegendItems: LegendItem[] = pitchTypes.map((pitchType) => ({
  label: pitchType,
  dotProps: { color: pitchTypeToColor[pitchType] },
}));

export const pitchTypeGroupLegendItems: LegendItem[] = pitchTypeGroups.map((pitchGroup) => ({
  label: pitchGroup,
  dotProps: { color: pitchTypeGroupToColor[pitchGroup] },
}));

export const playResultLegendItems: LegendItem[] = playResults.map((playResult) => ({
  label: playResult,
  dotProps: { color: playResultToColor[playResult], borderRadius: '1px' },
}));
